import { c as _c } from "react/compiler-runtime";
import { CmsVideoSource, CmsVideoSourceType } from '@spa/generated/graphql/graphql';
import { AiLabel } from '@spa/pages-converters/cms/components/convertCmsImage';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import HeadlineComponent from '../headline/headline.component';
import { LinkComponentLink } from '../link/link.component';
import { ReactElement } from 'react';
import VideoPlayerComponent from '../video-player/video-player.component';
import VimeoPlayerComponent from '../vimeo-player/vimeo-player.component';
import YoutubePlayerComponent from '../youtube-player/youtube-player.component';
import styles from './abstract-video-player.component.module.scss';
export interface Props {
  readonly id: string;
  readonly headline?: string | null;
  readonly subHeadline?: string | null;
  readonly headlineLink?: LinkComponentLink | null;
  readonly videoSrc: CmsVideoSource;
  readonly previewImageSrc: string | null;
  readonly previewImageAiLabel?: AiLabel | null;
  readonly autoplay: boolean;
  readonly muted: boolean;
  readonly alt: string;
  readonly height: number;
  readonly width: number;
  readonly editorMode: boolean;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
}
export default function AbstractVideoPlayerComponent(t0) {
  const $ = _c(37);
  const {
    id,
    headline,
    headlineLink,
    subHeadline,
    videoSrc,
    previewImageSrc,
    previewImageAiLabel,
    autoplay,
    muted,
    alt,
    height,
    width,
    editorMode,
    dateTo,
    dateFrom
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== autoplay || $[2] !== dateFrom || $[3] !== dateTo || $[4] !== editorMode || $[5] !== height || $[6] !== muted || $[7] !== previewImageSrc || $[8] !== width) {
    t1 = {
      previewImageSrc,
      autoplay,
      muted,
      alt,
      height,
      width,
      editorMode,
      dateTo,
      dateFrom
    };
    $[0] = alt;
    $[1] = autoplay;
    $[2] = dateFrom;
    $[3] = dateTo;
    $[4] = editorMode;
    $[5] = height;
    $[6] = muted;
    $[7] = previewImageSrc;
    $[8] = width;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const props = t1;
  let playerComponent;
  if (videoSrc.type === CmsVideoSourceType.LOCAL && videoSrc.url) {
    let t2;
    if ($[10] !== previewImageAiLabel || $[11] !== props || $[12] !== videoSrc.url) {
      t2 = <VideoPlayerComponent url={videoSrc.url} previewImageAiLabel={previewImageAiLabel} {...props} />;
      $[10] = previewImageAiLabel;
      $[11] = props;
      $[12] = videoSrc.url;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    playerComponent = t2;
  } else {
    if (videoSrc.type === CmsVideoSourceType.YOUTUBE && videoSrc.id) {
      let t2;
      if ($[14] !== previewImageAiLabel || $[15] !== props || $[16] !== videoSrc.id) {
        t2 = <YoutubePlayerComponent videoId={videoSrc.id} previewImageAiLabel={previewImageAiLabel} {...props} />;
        $[14] = previewImageAiLabel;
        $[15] = props;
        $[16] = videoSrc.id;
        $[17] = t2;
      } else {
        t2 = $[17];
      }
      playerComponent = t2;
    } else {
      if (videoSrc.type === CmsVideoSourceType.VIMEO && videoSrc.id) {
        let t2;
        if ($[18] !== previewImageAiLabel || $[19] !== props || $[20] !== videoSrc.id) {
          t2 = <VimeoPlayerComponent videoId={videoSrc.id} previewImageAiLabel={previewImageAiLabel} {...props} />;
          $[18] = previewImageAiLabel;
          $[19] = props;
          $[20] = videoSrc.id;
          $[21] = t2;
        } else {
          t2 = $[21];
        }
        playerComponent = t2;
      } else {
        let t2;
        if ($[22] !== props) {
          t2 = <VideoPlayerComponent url="assets/cms/videos/fallback.mp4" {...props} />;
          $[22] = props;
          $[23] = t2;
        } else {
          t2 = $[23];
        }
        playerComponent = t2;
      }
    }
  }
  let t2;
  if ($[24] !== headline || $[25] !== headlineLink || $[26] !== id || $[27] !== subHeadline) {
    t2 = headline && <HeadlineComponent id={`${id}-headline`} headline={headline} subHeadline={subHeadline ?? null} link={headlineLink ?? null} headlineTag="h2" />;
    $[24] = headline;
    $[25] = headlineLink;
    $[26] = id;
    $[27] = subHeadline;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  let t3;
  if ($[29] !== dateFrom || $[30] !== dateTo || $[31] !== editorMode) {
    t3 = editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />;
    $[29] = dateFrom;
    $[30] = dateTo;
    $[31] = editorMode;
    $[32] = t3;
  } else {
    t3 = $[32];
  }
  let t4;
  if ($[33] !== playerComponent || $[34] !== t2 || $[35] !== t3) {
    t4 = <div className={styles["abstract-video-player"]}>{t2}{t3}{playerComponent}</div>;
    $[33] = playerComponent;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
  } else {
    t4 = $[36];
  }
  return t4;
}